module.exports = __webpack_public_path__ + "static/media/orphans.41426662.jpg";